<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Sand Creek Ignites the Colorado War</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Slaves Become Soldiers</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. The Tenth Cavalry: “Ready and Forward”</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. The Battle of Beecher Island, 1868, and Sheridan’s Winter Campaign, 1868–69</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. The Battle of Summit Springs, 1869, and the Red River War, 1874–75</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. The Ninth Cavalry: “We Can, We Will!”</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. The Utes, Treaties, and Prospectors</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. The Ninth Cavalry in Colorado, 1875</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Meeker’s Troubles with the Utes</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. The Battle of Milk Creek, 1879</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. The Meeker Massacre, 1879</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. “The Utes Must Go!”</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. The Buffalo Soldiers and the Utes in Utah</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. The Later Years</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?4ed92bb8